import { planTypes } from '@/common/constants';
import { mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      logo: require('@/assets/plans/hardware_desk_phones.svg'),
      title: this.$t('billing.hw.desk_phones.addon.title'),
      planType: planTypes.ZOOM_DEVICE$DESK_PHONE,
      configDescription: 'configDescription',
      description: this.$t('billing.hw.desk_phones.addon.desc'),
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
      allPlanMap: state => state.ShoppingCart.allPlanMap
    }),
    ...mapGetters(['getSelectedPlans']),
    mx_planList() {
      return this.planMapFlat.filter((p) => p.type === planTypes.ZOOM_DEVICE$DESK_PHONE);
    },
    mx_currentSellerId() {
      return this.mx_planList[0]?.__originData?.sellerId
    },
    mx_currentVendorData() {
      return this.allPlanMap.__vendorsData?.vendors?.find(item => item.id === this.mx_currentSellerId)
    },
    mx_returnPolicy() {
      return this.mx_currentVendorData?.returnUrl
    },
    mx_privacyPolicy() {
      return this.mx_currentVendorData?.privacyUrl
    },
    mx_rmaUrl() {
      return this.mx_currentVendorData?.rmaUrl
    },
    mx_helpUrl() {
      return this.mx_currentVendorData?.helpUrl
    },
    mx_deskPhoneDialogProducts() {
      return this.mx_planList.map(item => {
        const selectedQuantity = item.cartInfo.selected_number;

        return {
          ...item.__originData,
          _disabled: !!selectedQuantity,
          _selected: !!selectedQuantity
        }
      })
    }
  },
};
